(() => {
  if (window.caCartRewardsInstalled) return;
  window.caCartRewardsInstalled = true;
  const style = document.createElement('style');
  style.textContent = `body.ca-cart-drawer-open #blp-container:has(#nav-close){z-index:2147483601!important}.ca-cart-rewards{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:10px 12px;margin:8px 0 12px;border:1px solid #b7dfe8;border-radius:14px;background:#eefbfc;color:#143746;font-size:13px;line-height:1.35}.ca-cart-rewards__balance{min-width:0;font-weight:600;overflow-wrap:anywhere}.ca-cart-rewards__link{flex-shrink:0;color:#08768f;font-weight:700;text-decoration:underline;text-underline-offset:3px}.ca-cart-rewards__link:focus-visible{outline:2px solid #08768f;outline-offset:4px;border-radius:3px}`;
  document.head.append(style);
  let pending = false;
  let lastPoints = null;
  function sync() {
    pending = false;
    const drawer = document.getElementById('MinimogCartDrawer');
    const summary = drawer?.querySelector('.m-cart-drawer__summary');
    if (!summary) return;
    let row = drawer.querySelector('.ca-cart-rewards');
    if (!row) {
      row = document.createElement('div');
      row.className = 'ca-cart-rewards';
      const balance = document.createElement('span');
      balance.className = 'ca-cart-rewards__balance';
      balance.setAttribute('aria-live', 'polite');
      const link = document.createElement('a');
      link.className = 'ca-cart-rewards__link';
      link.href = '/pages/rewards-and-benefits';
      link.textContent = 'View rewards';
      link.addEventListener('click', event => {
        const launcher = document.getElementById('nav-toggle-widget');
        if (!launcher) return;
        event.preventDefault();
        event.stopPropagation();
        launcher.click();
      });
      row.append(balance, link);
      summary.after(row);
    }
    const progress = document.querySelector('#nav-toggle-widget progress');
    const overview = document.querySelector('.point-summary--overview-balance__span');
    const raw = overview?.textContent?.replace(/,/g, '') ?? progress?.getAttribute('value');
    const points = raw !== null && raw !== undefined && raw.trim() !== '' ? Number(raw) : NaN;
    if (raw !== null && raw !== undefined) lastPoints = Number.isFinite(points) && points >= 0 ? points : null;
    const text = lastPoints !== null
      ? `${new Intl.NumberFormat('en-US', {maximumFractionDigits: 0}).format(lastPoints)} Reward Gems`
      : 'Your Reward Gems';
    const balance = row.querySelector('.ca-cart-rewards__balance');
    if (balance.textContent !== text) balance.textContent = text;
  }
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(sync);
  }
  const start = () => {
    const observer = new MutationObserver(schedule);
    observer.observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['value'], characterData: true});
    sync();
    window.addEventListener('pageshow', schedule);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
